var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgShapes4(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 19,
    viewBox: "0 0 20 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.76213e-08 9.49812C3.17269e-07 14.3806 9.99992 9.49812 9.99992 9.49812C9.99992 9.49812 -1.22027e-07 4.61563 9.76213e-08 9.49812Z",
    fill: "#E55733"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 9.49812C20 14.3806 10.0001 9.49812 10.0001 9.49812C10.0001 9.49812 20 4.61563 20 9.49812Z",
    fill: "#E55733"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.99856 17.9131C9.35031 20.3544 9.99852 9.49846 9.99852 9.49846C9.99852 9.49846 0.646817 15.4719 4.99856 17.9131Z",
    fill: "#E55733"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.0005 1.085C19.3523 3.52625 10.0006 9.49966 10.0006 9.49966C10.0006 9.49966 10.6488 -1.35625 15.0005 1.085Z",
    fill: "#E55733"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.9995 17.9131C10.6477 20.3544 9.99953 9.49847 9.99953 9.49847C9.99953 9.49847 19.3512 15.4719 14.9995 17.9131Z",
    fill: "#E55733"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.99949 1.085C0.647741 3.52625 9.99945 9.49966 9.99945 9.49966C9.99945 9.49966 9.35123 -1.35625 4.99949 1.085Z",
    fill: "#E55733"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShapes4);
export default __webpack_public_path__ + "static/media/shapes-4.b8407242b667e79785c4ec67aac1e2ee.svg";
export { ForwardRef as ReactComponent };